import { mapValues } from "lodash";
import { readString } from "react-papaparse";

import { ImportStatus } from "components/Importer/constants";

import { ModalTypes } from "constants/navigation";

import { openModalLink, openSaleEntryRoute } from "lib/navigation";

const isWhitespaceString = str => !/\S/.test(str);

export function buildLotsAndErrorsListFromCsvImport(
  fileContents,
  validationSchema,
) {
  const errors = [];
  let lineCount = 0;
  const lots = [];

  readString(fileContents, {
    header: true,
    skipEmptyLines: true,
    step: results => {
      lineCount += 1;
      if (results.errors.length > 0) {
        results.errors.forEach(parseError => {
          errors.push({ line: parseError.row + 1, error: parseError.message });
        });
      }

      try {
        const data = mapValues(results.data, value =>
          isWhitespaceString(value) ? "" : value,
        );
        validationSchema.validateSync(data);
        lots.push(data);
      } catch (e) {
        errors.push({ line: lineCount, error: e.message });
      }
    },
  });
  return { lots, errors };
}

export function onDefaultFileSuccess({ errors = [], saleType = null }) {
  openSaleEntryRoute(saleType);
  if (errors.length > 0) {
    openModalLink(ModalTypes.ImportSummary, {
      errors,
      type: ImportStatus.WARNING,
    });
  }
}
